import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 4l8 3v15l-8 -3z","key":"svg-0"}],["path",{"d":"M13 19h6v-15h-14","key":"svg-1"}]]

const IconDualScreen = createReactComponent('outline', 'dual-screen', 'DualScreen', __iconNode);

export default IconDualScreen;